import { useQuery } from '@tanstack/react-query';
import * as api from './reportsApi.js';

export const CURRENT_REPORT_KEY = ['reports', 'current'] as const;

export function useCurrentReport() {
  return useQuery({
    queryKey: CURRENT_REPORT_KEY,
    queryFn: api.fetchCurrentReport,
    staleTime: 60_000,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      return status === 'pending' || status === 'processing' ? 5_000 : false;
    },
  });
}
